export default {"src":"/_next/static/media/import-classroom.9f48ff1f.gif","height":112,"width":576,"blurWidth":0,"blurHeight":0};